import useWindowDimensions from '../../../hooks/useWindowDimensions';
import {Skeleton} from '@mantine/core';

export default function DashboardSkeleton() {
    const {width} = useWindowDimensions();
    const isMobile = width <= 768;

    return (
        <div className='DashboardSkeleton-container mainLayout__container'>
            <div className='mainLayout__aside'>
                <div className='sidebar-container'>
                    < Skeleton className='sidebar-content' width='100%' height='100%'/>
                </div>
            </div>
            <div className='mainLayout__main'>
                <div className='dashboard__layout'>
                    < Skeleton className='dashboard__header' width='100%' height='40px'/>

                    <div className='dashboard__bento'>
                        < Skeleton height='200px' width='100%' style={{gridColumn: '1 / 3'}}/>
                        < Skeleton height='300px' width='100%' style={{gridColumn: '3', gridRow: '1 / 3'}}/>
                        < Skeleton height='200px' width='100%'/>
                        < Skeleton height='200px' width='100%'/>
                        {!isMobile && < Skeleton height='100px' width='100%' style={{gridColumn: '1 / 4'}}/>}
                    </div>
                </div>
            </div>
        </div>
    )
}
